import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  openTolltip,
  closeTolltip,
} from '../../store/modules/TooltipManagerActions';

import styles from './TooltipCaller.scss';
import { isMobile } from 'utils/HTMLUtils';
const rootClassName = styles.rootClassName;

class TooltipCaller extends Component {
  key = null;

  constructor(props) {
    super(props);

    this.rootRef = React.createRef();

    this.toOpen = this.toOpen.bind(this);
    this.toClose = this.toClose.bind(this);
  }

  toOpen() {
    if (this.props.disabled || !this.props.text?.trim()) return;

    if (this.key) {
      this.props.openTolltip(
        this.props.text,
        this.rootRef.current.childNodes[0].getBoundingClientRect(),
        this.key,
        this.props.options
      );
    } else {
      this.key = this.props.openTolltip(
        this.props.text,
        this.rootRef.current.childNodes[0].getBoundingClientRect(),
        null,
        this.props.options
      ).payload.key;
    }
  }


  toClose() {
    this.props.closeTolltip(this.key);
  }

  componentWillUnmount() {
    this.toClose();
  }

  getClasses() {
    let allClasses = [rootClassName];
    if (this.props.className) {
      allClasses.push(this.props.className);
    }
    return allClasses.join(' ');
  }

  render() {

    const allProps = {
      className: this.getClasses(),
      onMouseOver: () => {
        if (!this.props.disabled) this.toOpen();
      },
      onMouseLeave: () => {
        if (!this.props.disabled) this.toClose();
      },
      onMouseOut: () => {
        if (!isMobile() && !this.props.disabled) {
          this.toClose();
        }
      },
      onMouseDown: () => {
        if (!isMobile() && !this.props.disabled) {
          this.toClose();
        }
      },
      onMouseUp: () => {
        if (!this.props.disabled) this.toClose();
      },
      ref: this.rootRef,
    };

    return (
      <div
        {...allProps}
        onTouchStart={() => {
          if (isMobile() && !this.props.disabled && this.props.text?.trim()) {
            this.toOpen();
          }
        }}
      >
        <div className={`${rootClassName}-content`}>{this.props.children}</div>
      </div>
    );
  }
}

TooltipCaller.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.object,
  children: PropTypes.any,
  disabled: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openTolltip,
      closeTolltip,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(TooltipCaller);
